import React, { useEffect } from "react";
import {
  FaArrowRight,
  FaRegClock,
  FaRegCalendarAlt,
  FaGraduationCap,
} from "react-icons/fa";
import { getAllPosts } from "../data/blogPosts";
import { applySeo, SITE_URL } from "../utils/seo";
import "./Blog.css";

function BlogList({ onOpenPost, onBook, onHome }) {
  const posts = getAllPosts();

  useEffect(() => {
    const cleanup = applySeo({
      title: "Blog & Rehberler | Almanya'da Ücretsiz Eğitim — Almanya Kampüs",
      description:
        "Almanya'da ücretsiz üniversite eğitimi, sıfır Almanca ile başvuru, öğrenci vizesi ve burslar hakkında güncel rehberler ve uzman tavsiyeleri.",
      canonical: SITE_URL + "/blog",
      keywords:
        "almanya eğitim blog, almanya üniversite rehberi, sıfır almanca, ücretsiz eğitim, öğrenci vizesi, almanya kampüs blog",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "Blog",
        name: "Almanya Kampüs Blog",
        url: SITE_URL + "/blog",
        description:
          "Almanya'da ücretsiz üniversite eğitimi ve başvuru süreci hakkında rehberler.",
        publisher: {
          "@type": "Organization",
          name: "Almanya Kampüs",
          logo: {
            "@type": "ImageObject",
            url: SITE_URL + "/logo.png",
          },
        },
        blogPost: posts.map((p) => ({
          "@type": "BlogPosting",
          headline: p.title,
          url: `${SITE_URL}/blog/${p.slug}`,
          datePublished: p.date,
          author: { "@type": "Organization", name: p.author },
        })),
      },
    });
    window.scrollTo(0, 0);
    return cleanup;
  }, [posts]);

  return (
    <div className="blog-page">
      <div className="blog-topbar">
        <button className="blog-brand" onClick={onHome}>
          <img src="/logo.png" alt="Almanya Kampüs" />
          <span>Almanya Kampüs</span>
        </button>
        <button className="blog-book-btn" onClick={onBook}>
          <FaGraduationCap /> Ücretsiz Görüşme Al
        </button>
      </div>

      <nav className="blog-breadcrumb" aria-label="breadcrumb">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            onHome();
          }}
        >
          Ana Sayfa
        </a>{" "}
        / <span>Blog</span>
      </nav>

      <div className="blog-list-wrap">
        <header className="blog-list-header">
          <span className="eyebrow">Blog & Rehberler</span>
          <h1>Almanya'da Eğitim Yolculuğunuz İçin Rehberler</h1>
          <p>
            Sıfır Almanca ile ücretsiz üniversite eğitimi, başvuru adımları,
            öğrenci vizesi ve burslar hakkında bilmeniz gereken her şey — uzman
            danışmanlarımızdan güncel ve uygulanabilir tavsiyeler.
          </p>
        </header>

        <div className="blog-grid">
          {posts.map((post) => (
            <a
              key={post.slug}
              className="blog-card"
              href={`/blog/${post.slug}`}
              onClick={(e) => {
                e.preventDefault();
                onOpenPost(post.slug);
              }}
            >
              <div className="blog-card-img">
                <img src={post.cover} alt={post.coverAlt} loading="lazy" />
                <span className="blog-card-cat">{post.category}</span>
              </div>
              <div className="blog-card-body">
                <div className="blog-card-meta">
                  <span>
                    <FaRegCalendarAlt /> {post.dateReadable}
                  </span>
                  <span>
                    <FaRegClock /> {post.readingTime} dk okuma
                  </span>
                </div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <span className="blog-card-readmore">
                  Yazıyı Oku <FaArrowRight />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogList;
